import db from '@/js/services/contracts/Database';
import Dexie from 'dexie';

export default {
  getAll() {
    return db.fields.where('sync_status').notEqual(2).toArray();
  },
  getAllAlreadySync() {
    return db.fields.where('sync_status').equals(0).toArray();
  },
  updateById(id, updateObj) {
    return db.fields.update(id, Dexie.deepClone(updateObj));
  },
  getById(ids) {
    return db.fields.where('id').equals(Number.parseInt(ids, 10)).first();
  },
  getByCode(code) {
    return db.fields.where('code').equals(code).first();
  },
  getByIdFull(id) {
    return db.fields.where('id').equals(Number.parseInt(id, 10)).with({ farmer: 'farmer' });
  },
  add(data) {
    return db.fields.add(Dexie.deepClone(data));
  },
  deleteById(id) {
    return db.fields.where('id').equals(id).delete();
  },
  deleteByProperty(key, value) {
    return db.fields.where(key).equals(value).delete();
  },
  getAllSyncPending() {
    return db.fields.where('sync_status').above(0).toArray();
  },

};
